import { Route } from 'types/route.type';

import { routes as notifications } from './features/notifications/routes';
import { routes as sites } from './features/sites/routes';
import { routes as viewFishGroup } from './features/view-fish-group/routes';

export const routes: Route[] = [...sites, ...viewFishGroup, ...notifications];
